import MobilePopupWrapper from './MobilePopupWrapper';

export default MobilePopupWrapper;